import { LazyLoader, Modal } from '@bp/ui-components';
import { CourseSettingsForm } from 'components/CourseSettingsForm/CourseSettingsForm';
import { GroupFormOther } from 'components/GroupForm/GroupFormOther';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';

type CourseProfileModalProps = {
  isOpen: boolean;
  courseUuid: string;
  onClose: () => void;
};

export const CourseProfileModal = ({ isOpen, courseUuid, onClose }: CourseProfileModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal title={t('common.editProfiles')} isOpen={isOpen} loading={loading} onRequestClose={onClose}>
      <Suspense fallback={<LazyLoader embedded forceHeight='30vh' />}>
        <GroupFormOther groupUuid={courseUuid} onLoad={setLoading} onClose={onClose} />
      </Suspense>
    </Modal>
  );
};
